import {
  selectRedirectPage,
  selectSessionAuth,
  setRedirectPage,
  useAppDispatch,
  useAppSelector,
} from '@aorg/store';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useHandleRedirectPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(selectSessionAuth);
  const redirectPage = useAppSelector(selectRedirectPage);

  useEffect(() => {
    if (isAuth && redirectPage) {
      navigate(redirectPage);
      dispatch(setRedirectPage(undefined));
    }
    if (!isAuth && location.pathname.includes('/survey')) {
      dispatch(setRedirectPage(location.pathname));
    }
    if (!isAuth && location.search && location.pathname === '/profile') {
      dispatch(setRedirectPage(location.pathname + location.search));
    }
  }, [dispatch, isAuth, location, redirectPage, navigate]);
}
